export default __webpack_public_path__ + "static/media/skill_bg.2adefbe0.jpg";